export class NoneState {
    text?: string

    constructor({
        text = "NADA POR AQUI"
    }: any) {
        this.text = text;
    }
}